import { Component, OnInit } from '@angular/core';
import { CommonHelperService } from 'src/app/core/utilities/common-helper/common-helper.service';
import { ThemeService } from 'src/app/core/theme/theme.service';
@Component({
  selector: 'app-new-business',
  templateUrl: './new-business.component.html',
  styleUrls: ['./new-business.component.scss']
})
export class NewBusinessComponent implements OnInit {
  darkMode: boolean = false;
  iFrame: boolean = false;
  Img = {
    light: '/assets/images/login-light.svg',
    dark: '/assets/images/login-dark.svg'
  };
  constructor(
    private commonHelper: CommonHelperService,
    private themeService: ThemeService
  ) {}

  ngOnInit(): void {
    // Respect user's saved preference; defaults to Light Mode for first-time visitors.
    const isDark = this.commonHelper.isDarkEnabled();
    this.darkMode = isDark;
    this.iFrame = isDark;
  }
}
